<footer class="footer">
  <div
    (click)="backToTop()"
    class="to-top cursor-pointer pt-2 pb-4 flex flex-column justify-content-center align-items-center"
  >
    <em class="fa-solid fa-sort-up top-arrow"></em>
    <div>{{ "footer.backToTop" | translate }}</div>
  </div>
  <div
    class="content px-7 grid mx-0 justify-content-between align-items-center"
  >
    <div class="col-12 col-md-9">


      <div class="my-2">
        <a
          (click)="reloadCurrentPage(1, 'Shipping and return')"
          class="no-underline regular-font"
        >{{ "footer.shippingAndReturn" | translate }}</a
        >
      </div>
      <div *ngIf="isShop" class="my-2">
        <a class="no-underline regular-font">{{
          "footer.sellOnMomoMarket" | translate
          }}</a>
      </div>
      <div class="my-2">
        <a
          (click)="navigatePage('account')"
          class="no-underline regular-font"
        >My Account</a
        >
      </div>
      <div class="my-2">
        <a
          (click)="navigatePage('contact-us')"
          *ngIf="!scConfig"
          class="no-underline regular-font"
        >{{ "footer.contactUs" | translate }}</a
        >
        <a
          *ngIf="scConfig"
          class="no-underline regular-font white-color"
          href="https://paysky.io/contact"
          target="_blank"
        >{{ "footer.contactUs" | translate }}</a
        >
      </div>

      <div class="my-2">
        <a
          (click)="reloadCurrentPage(4, 'About us')"
          *ngIf="!scConfig"
          class="no-underline regular-font"
        >{{ "footer.aboutUs" | translate }}</a
        >
        <a
          *ngIf="scConfig"
          class="no-underline regular-font white-color"
          href="https://paysky.io/about-paysky-payment-solutions/"
          target="_blank"
        >{{ "footer.aboutPaysky" | translate }}</a
        >
      </div>

    </div>
    <div
      *ngIf="!scConfig"
      class="col-12 col-md-3 flex-row justify-content-center mobile-center-footer d-contents"
    >
      <div class="width-icon">
        <div *ngIf="isSellerHub === 'seller-hub'" (click)="navigateToSellerHub()">
          <button type="button" class="marketplace-btn main-btn mobile-buy p-button p-component p-element" >
            <span class="p-button-label">  <img class="mr-3" alt="No Image" src="./././././assets/images/payment-icons/Frame.svg"/>{{"footer.sellOnMoMoButton" | translate}}</span>
          </button>
        </div>
        <div class="d-flex mb-3 justify-content-center">
          <div class="mx-3">
            <img
              alt="No Image"
              height="26"
              src="./././././assets/images/payment-icons/momo.png"
              width="43"
            />
          </div>
          <div class="mx-3">
            <img
              alt="No Image"
              height="26"
              src="./././././assets/images/payment-icons/mastercard.png"
              width="43"
            />
          </div>
          <div class="mx-3">
            <img
              alt="No Image"
              height="26"
              src="./././././assets/images/payment-icons/visa.png"
              width="43"
            />
          </div>
        </div>

      </div>
    </div>
    <div
      *ngIf="scConfig"
      class="col-12 col-md-3 flex-row justify-content-center"
    >
      <div class="width-icon">
        <div class="d-flex">
          <div class="mx-3" *ngFor="let link of footerLinks">
            <a
              class="nav-link"
              [href]="link.iconLink"
              target="_blank"
            ><em class="{{link.iconClass}}"></em
            ></a>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="copy-rights grid px-6 mx-0">
    <div class="flex col-12 col-md-9 align-items-center text-align-center">
      <span>
        <div class="my-2">
          <a
            (click)="reloadCurrentPage(2, 'Conditions of use')"
            class="no-underline regular-font footer-tag"
          >{{ "footer.conditionsOfUse" | translate }}</a
          >
        </div>
      </span>
      <span class="mx-3">
        <div class="my-2">
          <a
            (click)="reloadCurrentPage(3, 'Privacy policy')"
            class="no-underline regular-font footer-tag"
          >{{ "footer.privacyPolicy" | translate }}</a
          >
        </div>
      </span>
      <span class="mx-3">
        <div class="my-2">
          <a
            (click)="reloadCurrentPage(5, 'Terms and Conditions')"
            class="no-underline regular-font footer-tag"
          >Terms And Conditions</a
          >
        </div>
      </span>
    </div>
    <div class="flex col-12 col-md-3 align-items-center justify-content-end">
      <p> {{ '© ' + currentYear }},
        {{ scConfig === true ? ("footer.scRightsReserved" | translate) : ("footer.rightsReserved" | translate)
        }}
      </p>
    </div>
  </div>
</footer>
